"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6993],{

/***/ 89609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Box_Box; }
});

// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/ClassNameGenerator/ClassNameGenerator.js
var ClassNameGenerator = __webpack_require__(37078);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/createBox.js
var createBox = __webpack_require__(61354);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/Box/boxClasses.js

const boxClasses = (0,generateUtilityClasses/* default */.Z)('MuiBox', ['root']);
/* harmony default export */ var Box_boxClasses = (boxClasses);
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/Box/Box.js
'use client';





const Box = (0,createBox/* default */.Z)({
  defaultClassName: Box_boxClasses.root,
  generateClassName: ClassNameGenerator/* default.generate */.Z.generate
});
 false ? 0 : void 0;
/* harmony default export */ var Box_Box = (Box);

/***/ }),

/***/ 50734:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Slider_Slider; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/system/colorManipulator.js
var colorManipulator = __webpack_require__(2101);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/RtlProvider/index.js
var RtlProvider = __webpack_require__(82056);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/useSlotProps/useSlotProps.js
var useSlotProps = __webpack_require__(82963);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/isHostComponent/isHostComponent.js
var isHostComponent = __webpack_require__(90712);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/ownerDocument/ownerDocument.js
var ownerDocument = __webpack_require__(82690);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/useControlled/useControlled.js
var useControlled = __webpack_require__(19032);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/clamp/clamp.js
var clamp = __webpack_require__(7610);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/useIsFocusVisible/useIsFocusVisible.js
var useIsFocusVisible = __webpack_require__(36728);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/useForkRef/useForkRef.js
var useForkRef = __webpack_require__(33703);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/useEnhancedEffect/useEnhancedEffect.js
var useEnhancedEffect = __webpack_require__(73546);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/useEventCallback/useEventCallback.js
var useEventCallback = __webpack_require__(59948);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/visuallyHidden/visuallyHidden.js
var visuallyHidden = __webpack_require__(40375);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/extractEventHandlers/extractEventHandlers.js
var extractEventHandlers = __webpack_require__(99113);
;// CONCATENATED MODULE: ./node_modules/@mui/material/utils/areArraysEqual.js
function areArraysEqual(array1, array2, itemComparer = (a, b) => a === b) {
  return array1.length === array2.length && array1.every((value, index) => itemComparer(value, array2[index]));
}
/* harmony default export */ var utils_areArraysEqual = (areArraysEqual);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Slider/useSlider.js
'use client';






const INTENTIONAL_DRAG_COUNT_THRESHOLD = 2;
function asc(a, b) {
  return a - b;
}
function findClosest(values, currentValue) {
  var _values$reduce;
  const {
    index: closestIndex
  } = (_values$reduce = values.reduce((acc, value, index) => {
    const distance = Math.abs(currentValue - value);
    if (acc === null || distance < acc.distance || distance === acc.distance) {
      return {
        distance,
        index
      };
    }
    return acc;
  }, null)) != null ? _values$reduce : {};
  return closestIndex;
}
function trackFinger(event, touchId) {
  // The event is TouchEvent
  if (touchId.current !== undefined && event.changedTouches) {
    const touchEvent = event;
    for (let i = 0; i < touchEvent.changedTouches.length; i += 1) {
      const touch = touchEvent.changedTouches[i];
      if (touch.identifier === touchId.current) {
        return {
          x: touch.clientX,
          y: touch.clientY
        };
      }
    }
    return false;
  }

  // The event is MouseEvent
  return {
    x: event.clientX,
    y: event.clientY
  };
}
function valueToPercent(value, min, max) {
  return (value - min) * 100 / (max - min);
}
function percentToValue(percent, min, max) {
  return (max - min) * percent + min;
}
function getDecimalPrecision(num) {
  // This handles the case when num is very small (0.00000001), js will turn this into 1e-8.
  // When num is bigger than 1 or less than -1 it won't get converted to this notation so it's fine.
  if (Math.abs(num) < 1) {
    const parts = num.toExponential().split('e-');
    const matissaDecimalPart = parts[0].split('.')[1];
    return (matissaDecimalPart ? matissaDecimalPart.length : 0) + parseInt(parts[1], 10);
  }
  const decimalPart = num.toString().split('.')[1];
  return decimalPart ? decimalPart.length : 0;
}
function roundValueToStep(value, step, min) {
  const nearest = Math.round((value - min) / step) * step + min;
  return Number(nearest.toFixed(getDecimalPrecision(step)));
}
function setValueIndex({
  values,
  newValue,
  index
}) {
  const output = values.slice();
  output[index] = newValue;
  return output.sort(asc);
}
function focusThumb({
  sliderRef,
  activeIndex,
  setActive
}) {
  var _sliderRef$current, _doc$activeElement;
  const doc = (0,ownerDocument/* default */.Z)(sliderRef.current);
  if (!((_sliderRef$current = sliderRef.current) != null && _sliderRef$current.contains(doc.activeElement)) || Number(doc == null || (_doc$activeElement = doc.activeElement) == null ? void 0 : _doc$activeElement.getAttribute('data-index')) !== activeIndex) {
    var _sliderRef$current2;
    (_sliderRef$current2 = sliderRef.current) == null || _sliderRef$current2.querySelector(`[type="range"][data-index="${activeIndex}"]`).focus();
  }
  if (setActive) {
    setActive(activeIndex);
  }
}
function areValuesEqual(newValue, oldValue) {
  if (typeof newValue === 'number' && typeof oldValue === 'number') {
    return newValue === oldValue;
  }
  if (typeof newValue === 'object' && typeof oldValue === 'object') {
    return utils_areArraysEqual(newValue, oldValue);
  }
  return false;
}
const axisProps = {
  horizontal: {
    offset: percent => ({
      left: `${percent}%`
    }),
    leap: percent => ({
      width: `${percent}%`
    })
  },
  'horizontal-reverse': {
    offset: percent => ({
      right: `${percent}%`
    }),
    leap: percent => ({
      width: `${percent}%`
    })
  },
  vertical: {
    offset: percent => ({
      bottom: `${percent}%`
    }),
    leap: percent => ({
      height: `${percent}%`
    })
  }
};
const Identity = x => x;

// TODO: remove support for Safari < 13.
// https://caniuse.com/#search=touch-action
//
// Safari, on iOS, supports touch action since v13.
// Over 80% of the iOS phones are compatible
// in August 2020.
// Utilizing the CSS.supports method to check if touch-action is supported.
// Since CSS.supports is supported on all but Edge@12 and IE and touch-action
// is supported on both Edge@12 and IE if CSS.supports is not available that means that
// touch-action will be supported
let cachedSupportsTouchActionNone;
function doesSupportTouchActionNone() {
  if (cachedSupportsTouchActionNone === undefined) {
    if (typeof CSS !== 'undefined' && typeof CSS.supports === 'function') {
      cachedSupportsTouchActionNone = CSS.supports('touch-action', 'none');
    } else {
      cachedSupportsTouchActionNone = true;
    }
  }
  return cachedSupportsTouchActionNone;
}
/**
 *
 * Demos:
 *
 * - [Slider](https://mui.com/base-ui/react-slider/#hook)
 *
 * API:
 *
 * - [useSlider API](https://mui.com/base-ui/react-slider/hooks-api/#use-slider)
 */
function useSlider(parameters) {
  const {
    'aria-labelledby': ariaLabelledby,
    defaultValue,
    disabled = false,
    disableSwap = false,
    isRtl = false,
    marks: marksProp = false,
    max = 100,
    min = 0,
    name,
    onChange,
    onChangeCommitted,
    orientation = 'horizontal',
    rootRef: ref,
    scale = Identity,
    step = 1,
    shiftStep = 10,
    tabIndex,
    value: valueProp
  } = parameters;
  const touchId = react.useRef(undefined);
  // We can't use the :active browser pseudo-classes.
  // - The active state isn't triggered when clicking on the rail.
  // - The active state isn't transferred when inversing a range slider.
  const [active, setActive] = react.useState(-1);
  const [open, setOpen] = react.useState(-1);
  const [dragging, setDragging] = react.useState(false);
  const moveCount = react.useRef(0);
  const [valueDerived, setValueState] = (0,useControlled/* default */.Z)({
    controlled: valueProp,
    default: defaultValue != null ? defaultValue : min,
    name: 'Slider'
  });
  const handleChange = onChange && ((event, value, thumbIndex) => {
    // Redefine target to allow name and value to be read.
    // This allows seamless integration with the most popular form libraries.
    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
    // Clone the event to not override `target` of the original event.
    const nativeEvent = event.nativeEvent || event;
    // @ts-ignore The nativeEvent is function, not object
    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
    Object.defineProperty(clonedEvent, 'target', {
      writable: true,
      value: {
        value,
        name
      }
    });
    onChange(clonedEvent, value, thumbIndex);
  });
  const range = Array.isArray(valueDerived);
  let values = range ? valueDerived.slice().sort(asc) : [valueDerived];
  values = values.map(value => value == null ? min : (0,clamp/* default */.Z)(value, min, max));
  const marks = marksProp === true && step !== null ? [...Array(Math.floor((max - min) / step) + 1)].map((_, index) => ({
    value: min + step * index
  })) : marksProp || [];
  const marksValues = marks.map(mark => mark.value);
  const {
    isFocusVisibleRef,
    onBlur: handleBlurVisible,
    onFocus: handleFocusVisible,
    ref: focusVisibleRef
  } = (0,useIsFocusVisible/* default */.Z)();
  const [focusedThumbIndex, setFocusedThumbIndex] = react.useState(-1);
  const sliderRef = react.useRef(null);
  const handleFocusRef = (0,useForkRef/* default */.Z)(focusVisibleRef, sliderRef);
  const handleRef = (0,useForkRef/* default */.Z)(ref, handleFocusRef);
  const createHandleHiddenInputFocus = otherHandlers => event => {
    var _otherHandlers$onFocu;
    const index = Number(event.currentTarget.getAttribute('data-index'));
    handleFocusVisible(event);
    if (isFocusVisibleRef.current === true) {
      setFocusedThumbIndex(index);
    }
    setOpen(index);
    otherHandlers == null || (_otherHandlers$onFocu = otherHandlers.onFocus) == null || _otherHandlers$onFocu.call(otherHandlers, event);
  };
  const createHandleHiddenInputBlur = otherHandlers => event => {
    var _otherHandlers$onBlur;
    handleBlurVisible(event);
    if (isFocusVisibleRef.current === false) {
      setFocusedThumbIndex(-1);
    }
    setOpen(-1);
    otherHandlers == null || (_otherHandlers$onBlur = otherHandlers.onBlur) == null || _otherHandlers$onBlur.call(otherHandlers, event);
  };
  const changeValue = (event, valueInput) => {
    const index = Number(event.currentTarget.getAttribute('data-index'));
    const value = values[index];
    const marksIndex = marksValues.indexOf(value);
    let newValue = valueInput;
    if (marks && step == null) {
      const maxMarksValue = marksValues[marksValues.length - 1];
      if (newValue > maxMarksValue) {
        newValue = maxMarksValue;
      } else if (newValue < marksValues[0]) {
        newValue = marksValues[0];
      } else {
        newValue = newValue < value ? marksValues[marksIndex - 1] : marksValues[marksIndex + 1];
      }
    }
    newValue = (0,clamp/* default */.Z)(newValue, min, max);
    if (range) {
      // Bound the new value to the thumb's neighbours.
      if (disableSwap) {
        newValue = (0,clamp/* default */.Z)(newValue, values[index - 1] || -Infinity, values[index + 1] || Infinity);
      }
      const previousValue = newValue;
      newValue = setValueIndex({
        values,
        newValue,
        index
      });
      let activeIndex = index;

      // Potentially swap the index if needed.
      if (!disableSwap) {
        activeIndex = newValue.indexOf(previousValue);
      }
      focusThumb({
        sliderRef,
        activeIndex
      });
    }
    setValueState(newValue);
    setFocusedThumbIndex(index);
    if (handleChange && !areValuesEqual(newValue, valueDerived)) {
      handleChange(event, newValue, index);
    }
    if (onChangeCommitted) {
      onChangeCommitted(event, newValue);
    }
  };
  const createHandleHiddenInputKeyDown = otherHandlers => event => {
    var _otherHandlers$onKeyD;
    // The Shift + Up/Down keyboard shortcuts for moving the slider makes sense to be supported
    // only if the step is defined. If the step is null, this means tha the marks are used for specifying the valid values.
    if (step !== null) {
      const index = Number(event.currentTarget.getAttribute('data-index'));
      const value = values[index];
      let newValue = null;
      if ((event.key === 'ArrowLeft' || event.key === 'ArrowDown') && event.shiftKey || event.key === 'PageDown') {
        newValue = Math.max(value - shiftStep, min);
      } else if ((event.key === 'ArrowRight' || event.key === 'ArrowUp') && event.shiftKey || event.key === 'PageUp') {
        newValue = Math.min(value + shiftStep, max);
      }
      if (newValue !== null) {
        changeValue(event, newValue);
        event.preventDefault();
      }
    }
    otherHandlers == null || (_otherHandlers$onKeyD = otherHandlers.onKeyDown) == null || _otherHandlers$onKeyD.call(otherHandlers, event);
  };
  (0,useEnhancedEffect/* default */.Z)(() => {
    if (disabled && sliderRef.current.contains(document.activeElement)) {
      var _document$activeEleme;
      // This is necessary because Firefox and Safari will keep focus
      // on a disabled element:
      // https://codesandbox.io/p/sandbox/mui-pr-22247-forked-h151h?file=/src/App.js
      // @ts-ignore
      (_document$activeEleme = document.activeElement) == null || _document$activeEleme.blur();
    }
  }, [disabled]);
  if (disabled && active !== -1) {
    setActive(-1);
  }
  if (disabled && focusedThumbIndex !== -1) {
    setFocusedThumbIndex(-1);
  }
  const createHandleHiddenInputChange = otherHandlers => event => {
    var _otherHandlers$onChan;
    (_otherHandlers$onChan = otherHandlers.onChange) == null || _otherHandlers$onChan.call(otherHandlers, event);
    // @ts-ignore
    changeValue(event, event.target.valueAsNumber);
  };
  const previousIndex = react.useRef(undefined);
  let axis = orientation;
  if (isRtl && orientation === 'horizontal') {
    axis += '-reverse';
  }
  const getFingerNewValue = ({
    finger,
    move = false
  }) => {
    const {
      current: slider
    } = sliderRef;
    const {
      width,
      height,
      bottom,
      left
    } = slider.getBoundingClientRect();
    let percent;
    if (axis.indexOf('vertical') === 0) {
      percent = (bottom - finger.y) / height;
    } else {
      percent = (finger.x - left) / width;
    }
    if (axis.indexOf('-reverse') !== -1) {
      percent = 1 - percent;
    }
    let newValue;
    newValue = percentToValue(percent, min, max);
    if (step) {
      newValue = roundValueToStep(newValue, step, min);
    } else {
      const closestIndex = findClosest(marksValues, newValue);
      newValue = marksValues[closestIndex];
    }
    newValue = (0,clamp/* default */.Z)(newValue, min, max);
    let activeIndex = 0;
    if (range) {
      if (!move) {
        activeIndex = findClosest(values, newValue);
      } else {
        activeIndex = previousIndex.current;
      }

      // Bound the new value to the thumb's neighbours.
      if (disableSwap) {
        newValue = (0,clamp/* default */.Z)(newValue, values[activeIndex - 1] || -Infinity, values[activeIndex + 1] || Infinity);
      }
      const previousValue = newValue;
      newValue = setValueIndex({
        values,
        newValue,
        index: activeIndex
      });

      // Potentially swap the index if needed.
      if (!(disableSwap && move)) {
        activeIndex = newValue.indexOf(previousValue);
        previousIndex.current = activeIndex;
      }
    }
    return {
      newValue,
      activeIndex
    };
  };
  const handleTouchMove = (0,useEventCallback/* default */.Z)(nativeEvent => {
    const finger = trackFinger(nativeEvent, touchId);
    if (!finger) {
      return;
    }
    moveCount.current += 1;

    // Cancel move in case some other element consumed a mouseup event and it was not fired.
    // @ts-ignore buttons doesn't not exists on touch event
    if (nativeEvent.type === 'mousemove' && nativeEvent.buttons === 0) {
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      handleTouchEnd(nativeEvent);
      return;
    }
    const {
      newValue,
      activeIndex
    } = getFingerNewValue({
      finger,
      move: true
    });
    focusThumb({
      sliderRef,
      activeIndex,
      setActive
    });
    setValueState(newValue);
    if (!dragging && moveCount.current > INTENTIONAL_DRAG_COUNT_THRESHOLD) {
      setDragging(true);
    }
    if (handleChange && !areValuesEqual(newValue, valueDerived)) {
      handleChange(nativeEvent, newValue, activeIndex);
    }
  });
  const handleTouchEnd = (0,useEventCallback/* default */.Z)(nativeEvent => {
    const finger = trackFinger(nativeEvent, touchId);
    setDragging(false);
    if (!finger) {
      return;
    }
    const {
      newValue
    } = getFingerNewValue({
      finger,
      move: true
    });
    setActive(-1);
    if (nativeEvent.type === 'touchend') {
      setOpen(-1);
    }
    if (onChangeCommitted) {
      onChangeCommitted(nativeEvent, newValue);
    }
    touchId.current = undefined;

    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    stopListening();
  });
  const handleTouchStart = (0,useEventCallback/* default */.Z)(nativeEvent => {
    if (disabled) {
      return;
    }
    // If touch-action: none; is not supported we need to prevent the scroll manually.
    if (!doesSupportTouchActionNone()) {
      nativeEvent.preventDefault();
    }
    const touch = nativeEvent.changedTouches[0];
    if (touch != null) {
      // A number that uniquely identifies the current finger in the touch session.
      touchId.current = touch.identifier;
    }
    const finger = trackFinger(nativeEvent, touchId);
    if (finger !== false) {
      const {
        newValue,
        activeIndex
      } = getFingerNewValue({
        finger
      });
      focusThumb({
        sliderRef,
        activeIndex,
        setActive
      });
      setValueState(newValue);
      if (handleChange && !areValuesEqual(newValue, valueDerived)) {
        handleChange(nativeEvent, newValue, activeIndex);
      }
    }
    moveCount.current = 0;
    const doc = (0,ownerDocument/* default */.Z)(sliderRef.current);
    doc.addEventListener('touchmove', handleTouchMove, {
      passive: true
    });
    doc.addEventListener('touchend', handleTouchEnd, {
      passive: true
    });
  });
  const stopListening = react.useCallback(() => {
    const doc = (0,ownerDocument/* default */.Z)(sliderRef.current);
    doc.removeEventListener('mousemove', handleTouchMove);
    doc.removeEventListener('mouseup', handleTouchEnd);
    doc.removeEventListener('touchmove', handleTouchMove);
    doc.removeEventListener('touchend', handleTouchEnd);
  }, [handleTouchEnd, handleTouchMove]);
  react.useEffect(() => {
    const {
      current: slider
    } = sliderRef;
    slider.addEventListener('touchstart', handleTouchStart, {
      passive: doesSupportTouchActionNone()
    });
    return () => {
      slider.removeEventListener('touchstart', handleTouchStart);
      stopListening();
    };
  }, [stopListening, handleTouchStart]);
  react.useEffect(() => {
    if (disabled) {
      stopListening();
    }
  }, [disabled, stopListening]);
  const createHandleMouseDown = otherHandlers => event => {
    var _otherHandlers$onMous;
    (_otherHandlers$onMous = otherHandlers.onMouseDown) == null || _otherHandlers$onMous.call(otherHandlers, event);
    if (disabled) {
      return;
    }
    if (event.defaultPrevented) {
      return;
    }

    // Only handle left clicks
    if (event.button !== 0) {
      return;
    }

    // Avoid text selection
    event.preventDefault();
    const finger = trackFinger(event, touchId);
    if (finger !== false) {
      const {
        newValue,
        activeIndex
      } = getFingerNewValue({
        finger
      });
      focusThumb({
        sliderRef,
        activeIndex,
        setActive
      });
      setValueState(newValue);
      if (handleChange && !areValuesEqual(newValue, valueDerived)) {
        handleChange(event, newValue, activeIndex);
      }
    }
    moveCount.current = 0;
    const doc = (0,ownerDocument/* default */.Z)(sliderRef.current);
    doc.addEventListener('mousemove', handleTouchMove, {
      passive: true
    });
    doc.addEventListener('mouseup', handleTouchEnd);
  };
  const trackOffset = valueToPercent(range ? values[0] : min, min, max);
  const trackLeap = valueToPercent(values[values.length - 1], min, max) - trackOffset;
  const getRootProps = (externalProps = {}) => {
    const externalHandlers = (0,extractEventHandlers/* default */.Z)(externalProps);
    const ownEventHandlers = {
      onMouseDown: createHandleMouseDown(externalHandlers || {})
    };
    const mergedEventHandlers = (0,esm_extends/* default */.Z)({}, externalHandlers, ownEventHandlers);
    return (0,esm_extends/* default */.Z)({}, externalProps, {
      ref: handleRef
    }, mergedEventHandlers);
  };
  const createHandleMouseOver = otherHandlers => event => {
    var _otherHandlers$onMous2;
    (_otherHandlers$onMous2 = otherHandlers.onMouseOver) == null || _otherHandlers$onMous2.call(otherHandlers, event);
    const index = Number(event.currentTarget.getAttribute('data-index'));
    setOpen(index);
  };
  const createHandleMouseLeave = otherHandlers => event => {
    var _otherHandlers$onMous3;
    (_otherHandlers$onMous3 = otherHandlers.onMouseLeave) == null || _otherHandlers$onMous3.call(otherHandlers, event);
    setOpen(-1);
  };
  const getThumbProps = (externalProps = {}) => {
    const externalHandlers = (0,extractEventHandlers/* default */.Z)(externalProps);
    const ownEventHandlers = {
      onMouseOver: createHandleMouseOver(externalHandlers || {}),
      onMouseLeave: createHandleMouseLeave(externalHandlers || {})
    };
    return (0,esm_extends/* default */.Z)({}, externalProps, externalHandlers, ownEventHandlers);
  };
  const getThumbStyle = index => {
    return {
      // So the non active thumb doesn't show its label on hover.
      pointerEvents: active !== -1 && active !== index ? 'none' : undefined
    };
  };
  const getHiddenInputProps = (externalProps = {}) => {
    var _parameters$step;
    const externalHandlers = (0,extractEventHandlers/* default */.Z)(externalProps);
    const ownEventHandlers = {
      onChange: createHandleHiddenInputChange(externalHandlers || {}),
      onFocus: createHandleHiddenInputFocus(externalHandlers || {}),
      onBlur: createHandleHiddenInputBlur(externalHandlers || {}),
      onKeyDown: createHandleHiddenInputKeyDown(externalHandlers || {})
    };
    const mergedEventHandlers = (0,esm_extends/* default */.Z)({}, externalHandlers, ownEventHandlers);
    return (0,esm_extends/* default */.Z)({
      tabIndex,
      'aria-labelledby': ariaLabelledby,
      'aria-orientation': orientation,
      'aria-valuemax': scale(max),
      'aria-valuemin': scale(min),
      name,
      type: 'range',
      min: parameters.min,
      max: parameters.max,
      step: parameters.step === null && parameters.marks ? 'any' : (_parameters$step = parameters.step) != null ? _parameters$step : undefined,
      disabled
    }, externalProps, mergedEventHandlers, {
      style: (0,esm_extends/* default */.Z)({}, visuallyHidden/* default */.Z, {
        direction: isRtl ? 'rtl' : 'ltr',
        // So that VoiceOver's focus indicator matches the thumb's dimensions
        width: '100%',
        height: '100%'
      })
    });
  };
  return {
    active,
    axis: axis,
    axisProps,
    dragging,
    focusedThumbIndex,
    getHiddenInputProps,
    getRootProps,
    getThumbProps,
    marks: marks,
    open,
    range,
    rootRef: handleRef,
    trackLeap,
    trackOffset,
    values,
    getThumbStyle
  };
}
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/DefaultPropsProvider/DefaultPropsProvider.js
var DefaultPropsProvider = __webpack_require__(28628);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/slotShouldForwardProp.js
var slotShouldForwardProp = __webpack_require__(75536);
;// CONCATENATED MODULE: ./node_modules/@mui/material/utils/shouldSpreadAdditionalProps.js

const shouldSpreadAdditionalProps = Slot => {
  return !Slot || !(0,isHostComponent/* default */.Z)(Slot);
};
/* harmony default export */ var utils_shouldSpreadAdditionalProps = (shouldSpreadAdditionalProps);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/capitalize.js
var capitalize = __webpack_require__(98216);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Slider/sliderClasses.js


function getSliderUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.ZP)('MuiSlider', slot);
}
const sliderClasses = (0,generateUtilityClasses/* default */.Z)('MuiSlider', ['root', 'active', 'colorPrimary', 'colorSecondary', 'colorError', 'colorInfo', 'colorSuccess', 'colorWarning', 'disabled', 'dragging', 'focusVisible', 'mark', 'markActive', 'marked', 'markLabel', 'markLabelActive', 'rail', 'sizeSmall', 'thumb', 'thumbColorPrimary', 'thumbColorSecondary', 'thumbColorError', 'thumbColorSuccess', 'thumbColorInfo', 'thumbColorWarning', 'track', 'trackInverted', 'trackFalse', 'thumbSizeSmall', 'valueLabel', 'valueLabelOpen', 'valueLabelCircle', 'valueLabelLabel', 'vertical']);
/* harmony default export */ var Slider_sliderClasses = (sliderClasses);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Slider/SliderValueLabel.js
'use client';







const useValueLabelClasses = props => {
  const {
    open
  } = props;
  const utilityClasses = {
    offset: (0,clsx_m/* default */.Z)(open && Slider_sliderClasses.valueLabelOpen),
    circle: Slider_sliderClasses.valueLabelCircle,
    label: Slider_sliderClasses.valueLabelLabel
  };
  return utilityClasses;
};

/**
 * @ignore - internal component.
 */
function SliderValueLabel(props) {
  const {
    children,
    className,
    value
  } = props;
  const classes = useValueLabelClasses(props);
  if (!children) {
    return null;
  }
  return /*#__PURE__*/react.cloneElement(children, {
    className: (0,clsx_m/* default */.Z)(children.props.className)
  }, /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
    children: [children.props.children, /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: (0,clsx_m/* default */.Z)(classes.offset, className),
      "aria-hidden": true,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: classes.circle,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: classes.label,
          children: value
        })
      })
    })]
  }));
}
 false ? 0 : void 0;
;// CONCATENATED MODULE: ./node_modules/@mui/material/Slider/Slider.js
'use client';



const _excluded = ["aria-label", "aria-valuetext", "aria-labelledby", "component", "components", "componentsProps", "color", "classes", "className", "disableSwap", "disabled", "getAriaLabel", "getAriaValueText", "marks", "max", "min", "name", "onChange", "onChangeCommitted", "orientation", "shiftStep", "size", "step", "scale", "slotProps", "slots", "tabIndex", "track", "value", "valueLabelDisplay", "valueLabelFormat"];



















function Slider_Identity(x) {
  return x;
}
const SliderRoot = (0,styled/* default */.ZP)('span', {
  name: 'MuiSlider',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[`color${(0,capitalize/* default */.Z)(ownerState.color)}`], ownerState.size !== 'medium' && styles[`size${(0,capitalize/* default */.Z)(ownerState.size)}`], ownerState.marked && styles.marked, ownerState.orientation === 'vertical' && styles.vertical, ownerState.track === 'inverted' && styles.trackInverted, ownerState.track === false && styles.trackFalse];
  }
})(({
  theme
}) => {
  var _theme$vars;
  return {
    borderRadius: 12,
    boxSizing: 'content-box',
    display: 'inline-block',
    position: 'relative',
    cursor: 'pointer',
    touchAction: 'none',
    WebkitTapHighlightColor: 'transparent',
    '@media print': {
      colorAdjust: 'exact'
    },
    [`&.${Slider_sliderClasses.disabled}`]: {
      pointerEvents: 'none',
      cursor: 'default',
      color: (theme.vars || theme).palette.grey[400]
    },
    [`&.${Slider_sliderClasses.dragging}`]: {
      [`& .${Slider_sliderClasses.thumb}, & .${Slider_sliderClasses.track}`]: {
        transition: 'none'
      }
    },
    variants: [...Object.keys(((_theme$vars = theme.vars) != null ? _theme$vars : theme).palette).filter(key => {
      var _theme$vars2;
      return ((_theme$vars2 = theme.vars) != null ? _theme$vars2 : theme).palette[key].main;
    }).map(color => ({
      props: {
        color
      },
      style: {
        color: (theme.vars || theme).palette[color].main
      }
    })), {
      props: {
        orientation: 'horizontal'
      },
      style: {
        height: 4,
        width: '100%',
        padding: '13px 0',
        // The primary input mechanism of the device includes a pointing device of limited accuracy.
        '@media (pointer: coarse)': {
          // Reach 42px touch target, about ~8mm on screen.
          padding: '20px 0'
        }
      }
    }, {
      props: {
        orientation: 'horizontal',
        size: 'small'
      },
      style: {
        height: 2
      }
    }, {
      props: {
        orientation: 'horizontal',
        marked: true
      },
      style: {
        marginBottom: 20
      }
    }, {
      props: {
        orientation: 'vertical'
      },
      style: {
        height: '100%',
        width: 4,
        padding: '0 13px',
        // The primary input mechanism of the device includes a pointing device of limited accuracy.
        '@media (pointer: coarse)': {
          // Reach 42px touch target, about ~8mm on screen.
          padding: '0 20px'
        }
      }
    }, {
      props: {
        orientation: 'vertical',
        size: 'small'
      },
      style: {
        width: 2
      }
    }, {
      props: {
        orientation: 'vertical',
        marked: true
      },
      style: {
        marginRight: 44
      }
    }]
  };
});
const SliderRail = (0,styled/* default */.ZP)('span', {
  name: 'MuiSlider',
  slot: 'Rail',
  overridesResolver: (props, styles) => styles.rail
})({
  display: 'block',
  position: 'absolute',
  borderRadius: 'inherit',
  backgroundColor: 'currentColor',
  opacity: 0.38,
  variants: [{
    props: {
      orientation: 'horizontal'
    },
    style: {
      width: '100%',
      height: 'inherit',
      top: '50%',
      transform: 'translateY(-50%)'
    }
  }, {
    props: {
      orientation: 'vertical'
    },
    style: {
      height: '100%',
      width: 'inherit',
      left: '50%',
      transform: 'translateX(-50%)'
    }
  }, {
    props: {
      track: 'inverted'
    },
    style: {
      opacity: 1
    }
  }]
});
const SliderTrack = (0,styled/* default */.ZP)('span', {
  name: 'MuiSlider',
  slot: 'Track',
  overridesResolver: (props, styles) => styles.track
})(({
  theme
}) => {
  var _theme$vars3;
  return {
    display: 'block',
    position: 'absolute',
    borderRadius: 'inherit',
    border: '1px solid currentColor',
    backgroundColor: 'currentColor',
    transition: theme.transitions.create(['left', 'width', 'bottom', 'height'], {
      duration: theme.transitions.duration.shortest
    }),
    variants: [{
      props: {
        size: 'small'
      },
      style: {
        border: 'none'
      }
    }, {
      props: {
        orientation: 'horizontal'
      },
      style: {
        height: 'inherit',
        top: '50%',
        transform: 'translateY(-50%)'
      }
    }, {
      props: {
        orientation: 'vertical'
      },
      style: {
        width: 'inherit',
        left: '50%',
        transform: 'translateX(-50%)'
      }
    }, {
      props: {
        track: false
      },
      style: {
        display: 'none'
      }
    }, ...Object.keys(((_theme$vars3 = theme.vars) != null ? _theme$vars3 : theme).palette).filter(key => {
      var _theme$vars4;
      return ((_theme$vars4 = theme.vars) != null ? _theme$vars4 : theme).palette[key].main;
    }).map(color => ({
      props: {
        color,
        track: 'inverted'
      },
      style: (0,esm_extends/* default */.Z)({}, theme.vars ? {
        backgroundColor: theme.vars.palette.Slider[`${color}Track`],
        borderColor: theme.vars.palette.Slider[`${color}Track`]
      } : (0,esm_extends/* default */.Z)({
        backgroundColor: (0,colorManipulator/* lighten */.$n)(theme.palette[color].main, 0.62),
        borderColor: (0,colorManipulator/* lighten */.$n)(theme.palette[color].main, 0.62)
      }, theme.applyStyles('dark', {
        backgroundColor: (0,colorManipulator/* darken */._j)(theme.palette[color].main, 0.5)
      }), theme.applyStyles('dark', {
        borderColor: (0,colorManipulator/* darken */._j)(theme.palette[color].main, 0.5)
      })))
    }))]
  };
});
const SliderThumb = (0,styled/* default */.ZP)('span', {
  name: 'MuiSlider',
  slot: 'Thumb',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.thumb, styles[`thumbColor${(0,capitalize/* default */.Z)(ownerState.color)}`], ownerState.size !== 'medium' && styles[`thumbSize${(0,capitalize/* default */.Z)(ownerState.size)}`]];
  }
})(({
  theme
}) => {
  var _theme$vars5;
  return {
    position: 'absolute',
    width: 20,
    height: 20,
    boxSizing: 'border-box',
    borderRadius: '50%',
    outline: 0,
    backgroundColor: 'currentColor',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: theme.transitions.create(['box-shadow', 'left', 'bottom'], {
      duration: theme.transitions.duration.shortest
    }),
    '&::before': {
      position: 'absolute',
      content: '""',
      borderRadius: 'inherit',
      width: '100%',
      height: '100%',
      boxShadow: (theme.vars || theme).shadows[2]
    },
    '&::after': {
      position: 'absolute',
      content: '""',
      borderRadius: '50%',
      // 42px is the hit target
      width: 42,
      height: 42,
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)'
    },
    [`&.${Slider_sliderClasses.disabled}`]: {
      '&:hover': {
        boxShadow: 'none'
      }
    },
    variants: [{
      props: {
        size: 'small'
      },
      style: {
        width: 12,
        height: 12,
        '&::before': {
          boxShadow: 'none'
        }
      }
    }, {
      props: {
        orientation: 'horizontal'
      },
      style: {
        top: '50%',
        transform: 'translate(-50%, -50%)'
      }
    }, {
      props: {
        orientation: 'vertical'
      },
      style: {
        left: '50%',
        transform: 'translate(-50%, 50%)'
      }
    }, ...Object.keys(((_theme$vars5 = theme.vars) != null ? _theme$vars5 : theme).palette).filter(key => {
      var _theme$vars6;
      return ((_theme$vars6 = theme.vars) != null ? _theme$vars6 : theme).palette[key].main;
    }).map(color => ({
      props: {
        color
      },
      style: {
        [`&:hover, &.${Slider_sliderClasses.focusVisible}`]: (0,esm_extends/* default */.Z)({}, theme.vars ? {
          boxShadow: `0px 0px 0px 8px rgba(${theme.vars.palette[color].mainChannel} / 0.16)`
        } : {
          boxShadow: `0px 0px 0px 8px ${(0,colorManipulator/* alpha */.Fq)(theme.palette[color].main, 0.16)}`
        }, {
          '@media (hover: none)': {
            boxShadow: 'none'
          }
        }),
        [`&.${Slider_sliderClasses.active}`]: (0,esm_extends/* default */.Z)({}, theme.vars ? {
          boxShadow: `0px 0px 0px 14px rgba(${theme.vars.palette[color].mainChannel} / 0.16)`
        } : {
          boxShadow: `0px 0px 0px 14px ${(0,colorManipulator/* alpha */.Fq)(theme.palette[color].main, 0.16)}`
        })
      }
    }))]
  };
});
const Slider_SliderValueLabel = (0,styled/* default */.ZP)(SliderValueLabel, {
  name: 'MuiSlider',
  slot: 'ValueLabel',
  overridesResolver: (props, styles) => styles.valueLabel
})(({
  theme
}) => (0,esm_extends/* default */.Z)({
  zIndex: 1,
  whiteSpace: 'nowrap'
}, theme.typography.body2, {
  fontWeight: 500,
  transition: theme.transitions.create(['transform'], {
    duration: theme.transitions.duration.shortest
  }),
  position: 'absolute',
  backgroundColor: (theme.vars || theme).palette.grey[600],
  borderRadius: 2,
  color: (theme.vars || theme).palette.common.white,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '0.25rem 0.75rem',
  variants: [{
    props: {
      orientation: 'horizontal'
    },
    style: {
      transform: 'translateY(-100%) scale(0)',
      top: '-10px',
      transformOrigin: 'bottom center',
      '&::before': {
        position: 'absolute',
        content: '""',
        width: 8,
        height: 8,
        transform: 'translate(-50%, 50%) rotate(45deg)',
        backgroundColor: 'inherit',
        bottom: 0,
        left: '50%'
      },
      [`&.${Slider_sliderClasses.valueLabelOpen}`]: {
        transform: 'translateY(-100%) scale(1)'
      }
    }
  }, {
    props: {
      orientation: 'vertical'
    },
    style: {
      transform: 'translateY(-50%) scale(0)',
      right: '30px',
      top: '50%',
      transformOrigin: 'right center',
      '&::before': {
        position: 'absolute',
        content: '""',
        width: 8,
        height: 8,
        transform: 'translate(-50%, -50%) rotate(45deg)',
        backgroundColor: 'inherit',
        right: -8,
        top: '50%'
      },
      [`&.${Slider_sliderClasses.valueLabelOpen}`]: {
        transform: 'translateY(-50%) scale(1)'
      }
    }
  }, {
    props: {
      size: 'small'
    },
    style: {
      fontSize: theme.typography.pxToRem(12),
      padding: '0.25rem 0.5rem'
    }
  }, {
    props: {
      orientation: 'vertical',
      size: 'small'
    },
    style: {
      right: '20px'
    }
  }]
}));
const SliderMark = (0,styled/* default */.ZP)('span', {
  name: 'MuiSlider',
  slot: 'Mark',
  shouldForwardProp: prop => (0,slotShouldForwardProp/* default */.Z)(prop) && prop !== 'markActive',
  overridesResolver: (props, styles) => {
    const {
      markActive
    } = props;
    return [styles.mark, markActive && styles.markActive];
  }
})(({
  theme
}) => ({
  position: 'absolute',
  width: 2,
  height: 2,
  borderRadius: 1,
  backgroundColor: 'currentColor',
  variants: [{
    props: {
      orientation: 'horizontal'
    },
    style: {
      top: '50%',
      transform: 'translate(-1px, -50%)'
    }
  }, {
    props: {
      orientation: 'vertical'
    },
    style: {
      left: '50%',
      transform: 'translate(-50%, 1px)'
    }
  }, {
    props: {
      markActive: true
    },
    style: {
      backgroundColor: (theme.vars || theme).palette.background.paper,
      opacity: 0.8
    }
  }]
}));
const SliderMarkLabel = (0,styled/* default */.ZP)('span', {
  name: 'MuiSlider',
  slot: 'MarkLabel',
  shouldForwardProp: prop => (0,slotShouldForwardProp/* default */.Z)(prop) && prop !== 'markLabelActive',
  overridesResolver: (props, styles) => styles.markLabel
})(({
  theme
}) => (0,esm_extends/* default */.Z)({}, theme.typography.body2, {
  color: (theme.vars || theme).palette.text.secondary,
  position: 'absolute',
  whiteSpace: 'nowrap',
  variants: [{
    props: {
      orientation: 'horizontal'
    },
    style: {
      top: 30,
      transform: 'translateX(-50%)',
      '@media (pointer: coarse)': {
        top: 40
      }
    }
  }, {
    props: {
      orientation: 'vertical'
    },
    style: {
      left: 36,
      transform: 'translateY(50%)',
      '@media (pointer: coarse)': {
        left: 44
      }
    }
  }, {
    props: {
      markLabelActive: true
    },
    style: {
      color: (theme.vars || theme).palette.text.primary
    }
  }]
}));
const useUtilityClasses = ownerState => {
  const {
    disabled,
    dragging,
    marked,
    orientation,
    track,
    classes,
    color,
    size
  } = ownerState;
  const slots = {
    root: ['root', disabled && 'disabled', dragging && 'dragging', marked && 'marked', orientation === 'vertical' && 'vertical', track === 'inverted' && 'trackInverted', track === false && 'trackFalse', color && `color${(0,capitalize/* default */.Z)(color)}`, size && `size${(0,capitalize/* default */.Z)(size)}`],
    rail: ['rail'],
    track: ['track'],
    mark: ['mark'],
    markActive: ['markActive'],
    markLabel: ['markLabel'],
    markLabelActive: ['markLabelActive'],
    valueLabel: ['valueLabel'],
    thumb: ['thumb', disabled && 'disabled', size && `thumbSize${(0,capitalize/* default */.Z)(size)}`, color && `thumbColor${(0,capitalize/* default */.Z)(color)}`],
    active: ['active'],
    disabled: ['disabled'],
    focusVisible: ['focusVisible']
  };
  return (0,composeClasses/* default */.Z)(slots, getSliderUtilityClass, classes);
};
const Forward = ({
  children
}) => children;
const Slider = /*#__PURE__*/react.forwardRef(function Slider(inputProps, ref) {
  var _ref, _slots$root, _ref2, _slots$rail, _ref3, _slots$track, _ref4, _slots$thumb, _ref5, _slots$valueLabel, _ref6, _slots$mark, _ref7, _slots$markLabel, _ref8, _slots$input, _slotProps$root, _slotProps$rail, _slotProps$track, _slotProps$thumb, _slotProps$valueLabel, _slotProps$mark, _slotProps$markLabel, _slotProps$input;
  const props = (0,DefaultPropsProvider/* useDefaultProps */.i)({
    props: inputProps,
    name: 'MuiSlider'
  });
  const isRtl = (0,RtlProvider/* useRtl */.V)();
  const {
      'aria-label': ariaLabel,
      'aria-valuetext': ariaValuetext,
      'aria-labelledby': ariaLabelledby,
      // eslint-disable-next-line react/prop-types
      component = 'span',
      components = {},
      componentsProps = {},
      color = 'primary',
      classes: classesProp,
      className,
      disableSwap = false,
      disabled = false,
      getAriaLabel,
      getAriaValueText,
      marks: marksProp = false,
      max = 100,
      min = 0,
      orientation = 'horizontal',
      shiftStep = 10,
      size = 'medium',
      step = 1,
      scale = Slider_Identity,
      slotProps,
      slots,
      track = 'normal',
      valueLabelDisplay = 'off',
      valueLabelFormat = Slider_Identity
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    isRtl,
    max,
    min,
    classes: classesProp,
    disabled,
    disableSwap,
    orientation,
    marks: marksProp,
    color,
    size,
    step,
    shiftStep,
    scale,
    track,
    valueLabelDisplay,
    valueLabelFormat
  });
  const {
    axisProps,
    getRootProps,
    getHiddenInputProps,
    getThumbProps,
    open,
    active,
    axis,
    focusedThumbIndex,
    range,
    dragging,
    marks,
    values,
    trackOffset,
    trackLeap,
    getThumbStyle
  } = useSlider((0,esm_extends/* default */.Z)({}, ownerState, {
    rootRef: ref
  }));
  ownerState.marked = marks.length > 0 && marks.some(mark => mark.label);
  ownerState.dragging = dragging;
  ownerState.focusedThumbIndex = focusedThumbIndex;
  const classes = useUtilityClasses(ownerState);

  // support both `slots` and `components` for backward compatibility
  const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : SliderRoot;
  const RailSlot = (_ref2 = (_slots$rail = slots == null ? void 0 : slots.rail) != null ? _slots$rail : components.Rail) != null ? _ref2 : SliderRail;
  const TrackSlot = (_ref3 = (_slots$track = slots == null ? void 0 : slots.track) != null ? _slots$track : components.Track) != null ? _ref3 : SliderTrack;
  const ThumbSlot = (_ref4 = (_slots$thumb = slots == null ? void 0 : slots.thumb) != null ? _slots$thumb : components.Thumb) != null ? _ref4 : SliderThumb;
  const ValueLabelSlot = (_ref5 = (_slots$valueLabel = slots == null ? void 0 : slots.valueLabel) != null ? _slots$valueLabel : components.ValueLabel) != null ? _ref5 : Slider_SliderValueLabel;
  const MarkSlot = (_ref6 = (_slots$mark = slots == null ? void 0 : slots.mark) != null ? _slots$mark : components.Mark) != null ? _ref6 : SliderMark;
  const MarkLabelSlot = (_ref7 = (_slots$markLabel = slots == null ? void 0 : slots.markLabel) != null ? _slots$markLabel : components.MarkLabel) != null ? _ref7 : SliderMarkLabel;
  const InputSlot = (_ref8 = (_slots$input = slots == null ? void 0 : slots.input) != null ? _slots$input : components.Input) != null ? _ref8 : 'input';
  const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
  const railSlotProps = (_slotProps$rail = slotProps == null ? void 0 : slotProps.rail) != null ? _slotProps$rail : componentsProps.rail;
  const trackSlotProps = (_slotProps$track = slotProps == null ? void 0 : slotProps.track) != null ? _slotProps$track : componentsProps.track;
  const thumbSlotProps = (_slotProps$thumb = slotProps == null ? void 0 : slotProps.thumb) != null ? _slotProps$thumb : componentsProps.thumb;
  const valueLabelSlotProps = (_slotProps$valueLabel = slotProps == null ? void 0 : slotProps.valueLabel) != null ? _slotProps$valueLabel : componentsProps.valueLabel;
  const markSlotProps = (_slotProps$mark = slotProps == null ? void 0 : slotProps.mark) != null ? _slotProps$mark : componentsProps.mark;
  const markLabelSlotProps = (_slotProps$markLabel = slotProps == null ? void 0 : slotProps.markLabel) != null ? _slotProps$markLabel : componentsProps.markLabel;
  const inputSlotProps = (_slotProps$input = slotProps == null ? void 0 : slotProps.input) != null ? _slotProps$input : componentsProps.input;
  const rootProps = (0,useSlotProps/* default */.Z)({
    elementType: RootSlot,
    getSlotProps: getRootProps,
    externalSlotProps: rootSlotProps,
    externalForwardedProps: other,
    additionalProps: (0,esm_extends/* default */.Z)({}, utils_shouldSpreadAdditionalProps(RootSlot) && {
      as: component
    }),
    ownerState: (0,esm_extends/* default */.Z)({}, ownerState, rootSlotProps == null ? void 0 : rootSlotProps.ownerState),
    className: [classes.root, className]
  });
  const railProps = (0,useSlotProps/* default */.Z)({
    elementType: RailSlot,
    externalSlotProps: railSlotProps,
    ownerState,
    className: classes.rail
  });
  const trackProps = (0,useSlotProps/* default */.Z)({
    elementType: TrackSlot,
    externalSlotProps: trackSlotProps,
    additionalProps: {
      style: (0,esm_extends/* default */.Z)({}, axisProps[axis].offset(trackOffset), axisProps[axis].leap(trackLeap))
    },
    ownerState: (0,esm_extends/* default */.Z)({}, ownerState, trackSlotProps == null ? void 0 : trackSlotProps.ownerState),
    className: classes.track
  });
  const thumbProps = (0,useSlotProps/* default */.Z)({
    elementType: ThumbSlot,
    getSlotProps: getThumbProps,
    externalSlotProps: thumbSlotProps,
    ownerState: (0,esm_extends/* default */.Z)({}, ownerState, thumbSlotProps == null ? void 0 : thumbSlotProps.ownerState),
    className: classes.thumb
  });
  const valueLabelProps = (0,useSlotProps/* default */.Z)({
    elementType: ValueLabelSlot,
    externalSlotProps: valueLabelSlotProps,
    ownerState: (0,esm_extends/* default */.Z)({}, ownerState, valueLabelSlotProps == null ? void 0 : valueLabelSlotProps.ownerState),
    className: classes.valueLabel
  });
  const markProps = (0,useSlotProps/* default */.Z)({
    elementType: MarkSlot,
    externalSlotProps: markSlotProps,
    ownerState,
    className: classes.mark
  });
  const markLabelProps = (0,useSlotProps/* default */.Z)({
    elementType: MarkLabelSlot,
    externalSlotProps: markLabelSlotProps,
    ownerState,
    className: classes.markLabel
  });
  const inputSliderProps = (0,useSlotProps/* default */.Z)({
    elementType: InputSlot,
    getSlotProps: getHiddenInputProps,
    externalSlotProps: inputSlotProps,
    ownerState
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(RootSlot, (0,esm_extends/* default */.Z)({}, rootProps, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(RailSlot, (0,esm_extends/* default */.Z)({}, railProps)), /*#__PURE__*/(0,jsx_runtime.jsx)(TrackSlot, (0,esm_extends/* default */.Z)({}, trackProps)), marks.filter(mark => mark.value >= min && mark.value <= max).map((mark, index) => {
      const percent = valueToPercent(mark.value, min, max);
      const style = axisProps[axis].offset(percent);
      let markActive;
      if (track === false) {
        markActive = values.indexOf(mark.value) !== -1;
      } else {
        markActive = track === 'normal' && (range ? mark.value >= values[0] && mark.value <= values[values.length - 1] : mark.value <= values[0]) || track === 'inverted' && (range ? mark.value <= values[0] || mark.value >= values[values.length - 1] : mark.value >= values[0]);
      }
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(MarkSlot, (0,esm_extends/* default */.Z)({
          "data-index": index
        }, markProps, !(0,isHostComponent/* default */.Z)(MarkSlot) && {
          markActive
        }, {
          style: (0,esm_extends/* default */.Z)({}, style, markProps.style),
          className: (0,clsx_m/* default */.Z)(markProps.className, markActive && classes.markActive)
        })), mark.label != null ? /*#__PURE__*/(0,jsx_runtime.jsx)(MarkLabelSlot, (0,esm_extends/* default */.Z)({
          "aria-hidden": true,
          "data-index": index
        }, markLabelProps, !(0,isHostComponent/* default */.Z)(MarkLabelSlot) && {
          markLabelActive: markActive
        }, {
          style: (0,esm_extends/* default */.Z)({}, style, markLabelProps.style),
          className: (0,clsx_m/* default */.Z)(classes.markLabel, markLabelProps.className, markActive && classes.markLabelActive),
          children: mark.label
        })) : null]
      }, index);
    }), values.map((value, index) => {
      const percent = valueToPercent(value, min, max);
      const style = axisProps[axis].offset(percent);
      const ValueLabelComponent = valueLabelDisplay === 'off' ? Forward : ValueLabelSlot;
      return (
        /*#__PURE__*/
        /* TODO v6: Change component structure. It will help in avoiding the complicated React.cloneElement API added in SliderValueLabel component. Should be: Thumb -> Input, ValueLabel. Follow Joy UI's Slider structure. */
        (0,jsx_runtime.jsx)(ValueLabelComponent, (0,esm_extends/* default */.Z)({}, !(0,isHostComponent/* default */.Z)(ValueLabelComponent) && {
          valueLabelFormat,
          valueLabelDisplay,
          value: typeof valueLabelFormat === 'function' ? valueLabelFormat(scale(value), index) : valueLabelFormat,
          index,
          open: open === index || active === index || valueLabelDisplay === 'on',
          disabled
        }, valueLabelProps, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ThumbSlot, (0,esm_extends/* default */.Z)({
            "data-index": index
          }, thumbProps, {
            className: (0,clsx_m/* default */.Z)(classes.thumb, thumbProps.className, active === index && classes.active, focusedThumbIndex === index && classes.focusVisible),
            style: (0,esm_extends/* default */.Z)({}, style, getThumbStyle(index), thumbProps.style),
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(InputSlot, (0,esm_extends/* default */.Z)({
              "data-index": index,
              "aria-label": getAriaLabel ? getAriaLabel(index) : ariaLabel,
              "aria-valuenow": scale(value),
              "aria-labelledby": ariaLabelledby,
              "aria-valuetext": getAriaValueText ? getAriaValueText(scale(value), index) : ariaValuetext,
              value: values[index]
            }, inputSliderProps))
          }))
        }), index)
      );
    })]
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var Slider_Slider = (Slider);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/hooks/useActiveTheme.js
var useActiveTheme = __webpack_require__(56721);
;// CONCATENATED MODULE: ./node_modules/@care/react-component-lib/dist/components/Slider/Slider.js



const sliderStyles = (theme) => ({
    '& .MuiSlider-thumb': {
        backgroundColor: theme.palette.background.default,
        border: `2px solid ${theme.palette.state.selected}`,
        height: '24px',
        marginLeft: 0,
        top: '25px',
        width: '24px',
        '&:focus, &:hover, &:active, &:before': {
            boxShadow: 'none',
        },
    },
    '& .MuiSlider-track': {
        height: '16px',
        backgroundColor: theme.palette.state.selected,
        border: 'none',
        borderRadius: '16px',
    },
    '& .MuiSlider-rail': {
        height: '16px',
        backgroundColor: theme.palette.state.unselected,
        borderRadius: '16px',
        paddingLeft: '3px',
        paddingRight: '3px',
    },
    '& .MuiSlider-mark': {
        height: '8px',
        width: '8px',
        borderRadius: '4px',
        backgroundColor: theme.palette.care.grey[300],
        '&[data-index="0"]': {
            marginLeft: '6px',
        },
        marginLeft: '-10px',
    },
    '& .MuiSlider-markActive': {
        opacity: 1,
        height: '8px',
        width: '8px',
        borderRadius: '4px',
        backgroundColor: theme.palette.icon.contrast,
    },
    '@media (pointer: coarse)': {
        padding: '13px 0',
    },
});
/**
 * Renders a Slider with Care specific styling
 * @see {@link https://v5.mui.com/components/slider/ Material UI Slider} for slider usage information
 */
const Slider_Slider_Slider = ({ min, max, value, unit, hideUnitSeparator = false, step, onChange, inline, marks, prefix = '', suffix = '', maxSuffix = '', appendRange, timeMode, timeIncrements = 60, sx, }) => {
    const { isEmbraceTheme } = (0,useActiveTheme/* default */.Z)();
    const handleChange = (_, val) => {
        if (onChange)
            onChange(val);
    };
    const getTimeObject = (time) => {
        if (time === 0 || time === 24) {
            return { hour: 12, minute: 0, suffixIn: 'AM' };
        }
        const timeSuffix = time >= 12 ? 'PM' : 'AM';
        return {
            hour: time > 12 ? Math.floor(time - 12) : Math.floor(time),
            minute: (time - Math.floor(time)) * 60,
            suffixIn: timeSuffix,
        };
    };
    const generateStringTime = (timeObject) => {
        const { hour, minute, suffixIn } = timeObject;
        const hourOut = hour === 0 ? 12 : hour;
        const minuteOut = minute === 0 ? '00' : minute;
        const suffixOut = suffixIn;
        if (timeIncrements === 60) {
            return `${hourOut} ${suffixOut}`;
        }
        return `${hourOut}:${minuteOut} ${suffixOut}`;
    };
    const generateTimeLabel = () => {
        const val = value;
        if (typeof val === 'object') {
            const start = getTimeObject(val[0] < val[1] ? val[0] : val[1]);
            const end = getTimeObject(val[0] < val[1] ? val[1] : val[0]);
            return `${generateStringTime(start)}\u2013${generateStringTime(end)}`;
        }
        const time = getTimeObject(val);
        return `${generateStringTime(time)}`;
    };
    const generateAppended = (appendTo) => {
        return `${prefix}${appendTo}${suffix}`;
    };
    const generateSingleAppended = (appendTo) => {
        return `${prefix}${appendTo}${parseInt(appendTo, 10) === max ? maxSuffix : suffix}`;
    };
    const generateLabel = () => {
        if (timeMode) {
            return generateTimeLabel();
        }
        const val = value;
        let label;
        if (typeof val === 'object') {
            if (appendRange) {
                const first = generateAppended(`${val[0]}`);
                const second = generateAppended(`${val[1]}`);
                label = `${first}\u2013${second}`;
            }
            else {
                label = generateAppended(`${val[0]}\u2013${val[1]}`);
            }
        }
        else {
            label = generateSingleAppended(`${val}`);
        }
        return label;
    };
    const generateNormalSlider = () => {
        return (react.createElement(Grid/* default */.ZP, { container: true, item: true, spacing: 1, sx: sx },
            react.createElement(Grid/* default */.ZP, { item: true, xs: 12, mb: -1 },
                react.createElement(Typography/* default */.Z, { variant: isEmbraceTheme ? 'numeral3' : 'h1', component: "span", color: "state.selected", className: "bigLabel" }, generateLabel()),
                unit && (react.createElement(Typography/* default */.Z, { variant: "body2", component: "span", color: "text.secondary", ml: 1, className: "bigUnit" }, hideUnitSeparator ? unit : `/ ${unit}`))),
            react.createElement(Grid/* default */.ZP, { item: true, xs: 12 },
                react.createElement(Slider_Slider, { onChange: handleChange, value: value, step: timeMode ? timeIncrements / 60 : step, marks: marks, min: min, max: max, sx: sliderStyles }))));
    };
    const generateInlineSlider = () => {
        return (react.createElement(Grid/* default */.ZP, { container: true, item: true, spacing: 1 },
            react.createElement(Grid/* default */.ZP, { item: true, xs: 8 },
                react.createElement(Slider_Slider, { onChange: handleChange, value: value, step: timeMode ? timeIncrements / 60 : step, marks: marks, min: min, max: max, sx: sliderStyles })),
            react.createElement(Grid/* default */.ZP, { item: true, xs: 4, mt: "2px" },
                react.createElement(Typography/* default */.Z, { variant: "h4", component: "span", color: "state.selected", ml: 1, className: "inlineLabel" }, generateLabel()),
                unit && (react.createElement(Typography/* default */.Z, { component: "span", variant: "body2", color: "text.secondary", ml: 0.5, className: "inlineUnit" }, `/ ${unit}`)))));
    };
    const generateSlider = () => {
        if (inline === true) {
            return generateInlineSlider();
        }
        return generateNormalSlider();
    };
    return generateSlider();
};
/* harmony default export */ var components_Slider_Slider = (Slider_Slider_Slider);
//# sourceMappingURL=data:application/json;base64,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

/***/ })

}]);